module.exports = __webpack_public_path__ + "static/media/1010103.01058ce1.jpg";